import React from 'react';
import { CheckCircle2, Award, Users, Clock } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: 'Expert Technicians',
      description: 'Certified professionals with years of experience'
    },
    {
      icon: Users,
      title: 'Customer Focused',
      description: 'Dedicated to your satisfaction and trust'
    },
    {
      icon: Clock,
      title: 'Fast Turnaround',
      description: 'Efficient service without compromising quality'
    }
  ];

  const features = [
    'State-of-the-art diagnostic equipment',
    'Competitive pricing and transparent quotes',
    'Work with all major insurance companies',
    'Specialized in commercial fleet maintenance',
    'Quality parts and guaranteed workmanship',
    'Convenient North York location'
  ];

  return (
    <section id="about" className="relative py-24 bg-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://images.pexels.com/photos/4489776/pexels-photo-4489776.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Our mechanics at work"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/80 via-transparent to-transparent"></div>
            </div>

            {/* Floating Stats */}
            <div className="absolute bottom-8 left-8 right-8 bg-[#1a1a1a]/90 backdrop-blur-md border border-white/10 rounded-xl p-6">
              <div className="grid grid-cols-3 gap-6 text-center">
                <div>
                  <p className="text-2xl sm:text-3xl font-bold text-[#ff6b35]">Since</p>
                  <p className="text-xl sm:text-2xl font-bold text-[#ff6b35]">2002</p>
                  <p className="text-xs sm:text-sm text-gray-400 mt-1">Serving the GTA</p>
                </div>
                <div>
                  <p className="text-2xl sm:text-3xl font-bold text-[#ff6b35]">10K+</p>
                  <p className="text-xs sm:text-sm text-gray-400 mt-1">Vehicles Serviced</p>
                </div>
                <div>
                  <p className="text-2xl sm:text-3xl font-bold text-[#ff6b35]">100%</p>
                  <p className="text-xs sm:text-sm text-gray-400 mt-1">Satisfaction</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider mb-3 block">
              About Us
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Your Trusted Auto Care Partner Serving the GTA
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              Since 2002, Premium Auto Repairs & Sales has been committed to providing exceptional 
              automotive services throughout the Greater Toronto Area. Our experienced technicians combine 
              expertise with cutting-edge technology to deliver reliable repairs and maintenance for 
              all vehicle types.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              {highlights.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="text-center sm:text-left">
                    <div className="w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center mb-3 mx-auto sm:mx-0">
                      <IconComponent className="w-6 h-6 text-[#ff6b35]" />
                    </div>
                    <h4 className="text-white font-semibold mb-1">{item.title}</h4>
                    <p className="text-gray-500 text-sm">{item.description}</p>
                  </div>
                );
              })}
            </div>

            {/* Features List */}
            <div className="space-y-3 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#ff6b35] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">{feature}</span>
                </div>
              ))}
            </div>

            <p className="text-gray-400 leading-relaxed">
              Whether you need routine maintenance, major repairs, or fleet servicing for your 
              business, we have the skills and equipment to get the job done right. We work 
              directly with insurance companies to make body repairs hassle-free.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
